import { createContext } from "react";

// this is the set of genes entered by the user

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SuggestionContext = createContext([] as Array<any>);
